import { faTrash } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useNavigate } from "react-router";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { ModalFooter } from "../components/layout/ModalProvider";

export const PermanentDeleteInspectionModal: FC<{ inspection: Inspection }> = (props) => {
  const navigate = useNavigate();
  const { refreshAll } = useApi();
  const { destroyInspection } = useApiCall();
  const confirm = async () => {
    await destroyInspection(props.inspection.id);
    await refreshAll();
    navigate("/");
  };
  return (
    <>
      <div>Je staat op het punt om de volgende inspectie permanent te verwijderen.</div>
      <div className={"font-semibold my-2"}>
        &middot; <span>{props.inspection.name}</span>
      </div>
      <div>
        Bij het uitvoeren van deze actie worden ook alle bevindingen, resultaten, foto&apos;s en
        bijlagen van deze inspectie verwijderd.
      </div>

      <div className={"mt-4 text-red-500"}>Let op! Deze actie valt niet terug te draaien.</div>
      <ModalFooter text={"Verwijder"} icon={faTrash} onSubmit={confirm} />
    </>
  );
};
